var initMap = function () {
	'use strict';

	var markers = [];
	var centerPoint = {lat:48.3613632, lng:-1.7760817000000002 };
	var currentLatLng = {lat:'', lng:''};
	var map;
	var bounds;
	var allowedBounds = false;
	var windowWidth = window.innerWidth
				|| document.documentElement.clientWidth
				|| document.body.clientWidth;

	var isDesktop = windowWidth >= 1024 ? true : false;

	var initialMapZoom = windowWidth > 980 ? 6 : 5;
	var origin, direction, destination;
	var route_loaded = false;

	var init = function () {
		if (document.querySelector('[data-js-map]') === null) {
			return null;
		}

		$.get('/aosogitec/gmap_addresses', function (json) {
			// var destination = '';

			$(json).each(function (i, item) {
				var latlng = {lat: parseFloat(item.lat), lng: parseFloat(item.lng)};

				if (i == 0) {
					map = new google.maps.Map(document.querySelector('[data-js-map]'), {
						center: centerPoint,
						zoom: initialMapZoom,
						zoomControl: true,
						scrollwheel: false
					});

					if (!isDesktop) {
						console.log('mobile drag');
						map.setOptions({draggable: false});
					}

					direction = new google.maps.DirectionsRenderer({
						map: map
					});

					bounds = new google.maps.LatLngBounds();
				}

				var marker = new google.maps.Marker({
					position: latlng,
					map: map,
					title: item.title,
					icon: '/themes/custom/sogitec/assets/images/about-us/marker.png',
					html: item
				});

				markers.push(marker);
			});

			for (var i = 0; i < markers.length; i++) {
				markers[i].addListener('mousedown', function () {
					document.querySelector('.map-title').innerHTML = this.title;
					document.querySelector('.map-image').innerHTML = this.html.image ? '<img src="'+this.html.image+'" alt="">' : '';
					document.querySelector('.map-address').innerHTML = this.html.address;
					document.querySelector('.map-phone').innerHTML = this.html.phone;
					if (this.html.pdf) {
						document.querySelector('.map-route').setAttribute('href', this.html.pdf);
						document.querySelector('.map-route').style.display = 'block';
					}
					else {
						document.querySelector('.map-route').style.display = 'none';
					}
					document.querySelector('.map-fax').innerHTML = this.html.fax;
					document.querySelector('.slide-text').classList.add('active');

					destination = this.position.lat()+','+this.position.lng();

					initEvents();
					direction.set('directions', null);
				});

				bounds.extend(markers[i].getPosition());
			}

			if (navigator.geolocation) {
				var watchID = navigator.geolocation.getCurrentPosition(function (position) {
					origin = position.coords.latitude+', '+position.coords.longitude;
				});
			}
			else {
			  alert(gmap_errors.error1);
			}

			/*google.maps.event.addListener(map, 'idle', function() {
				if (!allowedBounds) {
					allowedBounds = map.getBounds();

					// map.fitBounds(bounds);
					paddedBounds(100, 20, 60, 40);

					if (windowWidth > 980 ? 6 : 5) {
						map.setZoom(6);
					}
					else {
						map.setZoom(5);
					}
				}
			});*/

		});

		document.querySelector('.map-close').addEventListener('click', function () {
			document.querySelector('.map-panel.desktop').style.display = 'none';
			document.querySelector('.map-panel.mobile').style.display = 'none';
			direction.set('directions', null);
			map.setZoom(initialMapZoom);
			route_loaded = false;
		});
	}

	var initEvents = function () {
		document.querySelector('.map-plans').removeEventListener('click', clickMapRoute);
		// document.querySelector('.map-route').removeEventListener('click', clickMapRoute);
		document.querySelector('.map-transport').removeEventListener('click', clickMapTransport);

		document.querySelector('.map-plans').addEventListener('click', clickMapRoute);
		// document.querySelector('.map-route').addEventListener('click', clickMapRoute);
		document.querySelector('.map-transport').addEventListener('click', clickMapTransport);
	}

	var checkOrigin = function () {
		if (typeof(origin) == 'undefined') {
			alert(gmap_errors.error2);
			return false;
		}
		return true;
	}

	var clickMapRoute = function () {
		if (!checkOrigin()) return;
		drawDirections(direction, map, origin, destination, 'route');
	}

	var clickMapTransport = function () {
		if (!checkOrigin()) return;
		drawDirections(direction, map, origin, destination, 'transport');
	}

	var clickPlans = function () {
		if (!checkOrigin()) return;
		if (!route_loaded)
			drawDirections(direction, map, origin, destination, 'route');
		else {
			if (windowWidth > 980)
	        	document.querySelector('.map-panel.desktop').style.display = document.querySelector('.map-panel.desktop').style.display == 'block' ? 'none' : 'block';
        	else
	        	document.querySelector('.map-panel.mobile').style.display = document.querySelector('.map-panel.mobile').style.display == 'block' ? 'none' : 'block';
		}
	}

	var drawDirections = function (direction, map, origin, destination, type) {
		var travelMode = google.maps.DirectionsTravelMode.DRIVING;
		if (type == 'transport') {
			travelMode = google.maps.DirectionsTravelMode.TRANSIT;
		}

		var request = {
			origin      : origin,
			destination : destination,
			travelMode  : travelMode,
			transitOptions: {modes:['RAIL', 'BUS', 'SUBWAY']}
		}
		var directionsService = new google.maps.DirectionsService();
		directionsService.route(request, function (response, status){
		    if(status == google.maps.DirectionsStatus.OK){
		    	route_loaded = true;
		    	direction.set('directions', null);
		        direction.setDirections(response);


	        	if (windowWidth > 980) {
		        	direction.setPanel(document.querySelector('.map-panel.desktop .map-panel-wrapper'));
		        	document.querySelector('.map-panel.desktop').style.display = 'none';
		        	document.querySelector('.map-panel.desktop').style.display = 'block';
	        	}
	        	else {
		        	direction.setPanel(document.querySelector('.map-panel.mobile .map-panel-wrapper'));
	        		document.querySelector('.map-panel.mobile').style.display = 'none';
		        	document.querySelector('.map-panel.mobile').style.display = 'block';
	        	}
		    }
		    else {
		    	alert(gmap_errors.error3)
		    }
		});
	}

	var paddedBounds = function (npad, spad, epad, wpad) {
		var SW = map.getBounds().getSouthWest();
		var NE = map.getBounds().getNorthEast();
		var topRight = map.getProjection().fromLatLngToPoint(NE);
		var bottomLeft = map.getProjection().fromLatLngToPoint(SW);
		var scale = Math.pow(2, map.getZoom());

		var SWtopoint = map.getProjection().fromLatLngToPoint(SW);
		var SWpoint = new google.maps.Point(((SWtopoint.x - bottomLeft.x) * scale) + wpad, ((SWtopoint.y - topRight.y) * scale) - spad);
		var SWworld = new google.maps.Point(SWpoint.x / scale + bottomLeft.x, SWpoint.y / scale + topRight.y);
		var pt1 = map.getProjection().fromPointToLatLng(SWworld);

		var NEtopoint = map.getProjection().fromLatLngToPoint(NE);
		var NEpoint = new google.maps.Point(((NEtopoint.x - bottomLeft.x) * scale) - epad, ((NEtopoint.y - topRight.y) * scale) + npad);
		var NEworld = new google.maps.Point(NEpoint.x / scale + bottomLeft.x, NEpoint.y / scale + topRight.y);
		var pt2 = map.getProjection().fromPointToLatLng(NEworld);

		return new google.maps.LatLngBounds(pt1, pt2);
	};

	return {
		init: init
	};
};
var gMap = new initMap();
gMap.init();


